import * as Yup from 'yup';

import { combineSchemas } from 'common/utils';
import { Fields, SelectOption, StatusOption } from 'common/types';

export type ProgramFields = {
  title: string;
  status: StatusOption[];
  description: string;
  short_description: string;
  category: SelectOption<string>[];
};

export const fields: Fields<ProgramFields> = {
  title: {
    label: 'Title',
    name: 'title',
    schema: Yup.string().required(),
  },
  short_description: {
    label: 'Short description',
    name: 'short_description',
    schema: Yup.string().required(),
  },
  description: {
    label: 'Description',
    name: 'description',
    schema: Yup.string().required(),
  },
  status: {
    label: 'Status',
    name: 'status',
    schema: Yup.array().required(),
  },
  category: {
    label: 'Categories',
    name: 'category',
    schema: Yup.array().required(),
  },
};

export const validationSchema = Yup.object().shape<ProgramFields>(combineSchemas(fields));

export type ProgramsTagsFields = {
  category: SelectOption<string>[];
  gender: SelectOption<string>;
};

export const tagsFields: Fields<ProgramsTagsFields> = {
  category: {
    label: 'Category',
    name: 'category',
    schema: Yup.array().required('Category is a required field'),
  },
  gender: {
    label: 'Gender',
    name: 'gender',
    schema: Yup.array().nullable(),
  },
};

export const programsTagsValidationSchema = Yup.object().shape<ProgramsTagsFields>(
  combineSchemas(tagsFields),
);

export type ProgramCategoryMap = Record<string, string>;
